import { Component, Input, OnInit } from '@angular/core';
import { EmplacementService } from '../services/emplacement-service';
import { PrevisionMeteo } from '../entites/prevision-meteo';
import { Observable } from 'rxjs';
import { AppMainComponent } from '../app.main.component';
import { DonneesBaseService } from '../services/donnees-base-service';
import { Emplacement } from '../entites/emplacement';
@Component({
  selector: 'app-prevision-meteo',
  templateUrl: './prevision-meteo.component.html',
  styleUrls: ['./prevision-meteo.component.scss']
})
export class PrevisionMeteoComponent implements OnInit {
  @Input() emplacementId!: number;
  @Input() date?: Date = new Date();
  
  previsionMeteo$!: Observable<PrevisionMeteo[]>;
  alertData: PrevisionMeteo | null = null;
  isAlertDescriptionExpanded: boolean = false;

  constructor(
    private emplacementService: EmplacementService,
    public appMain: AppMainComponent,
    private sdb: DonneesBaseService
  ) {}

  ngOnInit() {
    this.previsionMeteo$ = this.emplacementService.ObtenirPrevisionMeteo(this.emplacementId, this.date);
    this.previsionMeteo$.subscribe(previsions => {
      if (previsions.length > 0 && previsions[0].alerteTitre) {
        this.alertData = previsions[0];
      }
    });
  }

  getWeatherIconUrl(code: number): string {
    return `https://openweathermap.org/img/wn/${code}@2x.png`;
  }

  getTimeOfDay(date: Date): string {
    const hour = new Date(date).getUTCHours();
    if (hour === 3) return 'Matin';
    if (hour === 9) return 'Jour';
    if (hour === 15) return 'Soir';
    if (hour === 21) return 'Nuit';
    return '';
  }

  getWindDirection(degrees: number): string {
    const directions = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];
    const index = Math.round(degrees / 22.5) % 16;
    return directions[index];
  }

  getMeteomediaLink(): string {
    const emplacement = this.sdb.Emplacement(this.emplacementId);
    if (!emplacement || !emplacement.adresse || !emplacement.adresse.municipalite || !emplacement.adresse.province) return '';
    const ville = emplacement.adresse.municipalite.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const province = emplacement.adresse.province.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return `https://www.meteomedia.com/fr/ville/ca/${province}/${ville}/actuelle`;
  }

  toggleAlertDescription(): void {
    this.isAlertDescriptionExpanded = !this.isAlertDescriptionExpanded;
  }
} 